import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "force_play_outline",
  "use": "force_play_outline-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"force_play_outline\"><path d=\"M15.55 7.95 7.5 2.09a.9.9 0 0 0-.55-.18.95.95 0 0 0-.95.95v5.39H3.5V2H2v14h1.5V9.75H6v5.39c0 .56.46.95.95.95.19 0 .38-.06.55-.18l8.05-5.85a1.3 1.3 0 0 0 0-2.11m-8.05 6.1V3.95L14.45 9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol